class DisclosurePanelElement extends HTMLElement {
  connectedCallback() {
    this._details = this.querySelector('details');
    this._content = this.querySelector('[data-ref="content"]');

    this._openIfHashTargetInside();
    window.addEventListener('hashchange', this._handleHashChange);
  }

  disconnectedCallback() {
    window.removeEventListener('hashchange', this._handleHashChange);
  }

  _handleHashChange = () => this._openIfHashTargetInside();

  _openIfHashTargetInside() {
    const hash = window.location.hash.slice(1);
    if (!hash) {
      return;
    }

    const target = document.querySelector(`[name="${CSS.escape(hash)}"]`);
    if (target && this._content.contains(target)) {
      this._details.open = true;
    }
  }
}

customElements.define('chh-disclosure-panel', DisclosurePanelElement);

export default DisclosurePanelElement;
